import { BRAZIL } from "./areaCodes";

export const BRAZIL_REGEX = `^0?0?(55|550){0,2}(${BRAZIL.join("|")}){1}?[9]{0,1}([^a-zA-Z]){8}$`;
